import { render, staticRenderFns } from "./TalkWithGuideIntro.vue?vue&type=template&id=63f020fc&"
import script from "./TalkWithGuideIntro.vue?vue&type=script&lang=js&"
export * from "./TalkWithGuideIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports